import React, { useState } from "react";
import { toast } from "react-toastify";
import Handler from "../../../Helpers/Handler";
import { formatDateTime } from "../../../Helpers/Utils";

// Start early (admin only, Booking Flow v2 D6). The start photos and Start trip open the booking's
// start window before the pickup time (30 minutes by default, Settings > Booking Policy). An admin can
// open it now for this one booking, with a reason that is kept on the booking
// (tripDetails.earlyStart). Staff and the customer can then do the start steps as usual.

const REASON_MIN = 5;
const REASON_MAX = 200;

const EarlyStartModal = ({ bookingId, opensAt, minutes, onClose, onAllowed }) => {
    const [reason, setReason] = useState("");
    const [submitting, setSubmitting] = useState(false);
    const length = reason.trim().length;
    const valid = length >= REASON_MIN && length <= REASON_MAX;

    const submit = async () => {
        if (!valid) { toast.error(`Give a reason (${REASON_MIN} to ${REASON_MAX} characters)`); return; }
        setSubmitting(true);
        const response = await Handler({ method: "patch", url: `/admin/booking/trip/early-start/${bookingId}`, data: { reason: reason.trim() } });
        setSubmitting(false);
        if (response?.success) {
            toast.success("Early start allowed. The start photos and Start trip are open now");
            onAllowed?.();
            onClose?.();
        } else {
            toast.error(response?.data?.message || "Could not allow the early start");
        }
    };

    return (
        <>
            <div className="modal fade show" style={{ display: "block" }} tabIndex="-1">
                <div className="modal-dialog">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title">Start Early</h5>
                            <button type="button" className="btn-close" onClick={onClose} disabled={submitting}></button>
                        </div>
                        <div className="modal-body">
                            <p className="small text-muted">
                                This trip can normally be started from {minutes ?? 30} minutes before pickup{opensAt ? ` (${formatDateTime(opensAt)})` : ""}.
                                Allowing an early start opens the start photos and Start trip now, for staff and the customer too. The reason is kept on the booking.
                            </p>
                            <label className="form-label small" htmlFor="early-start-reason">Reason</label>
                            <textarea
                                id="early-start-reason"
                                className="form-control"
                                rows={3}
                                maxLength={REASON_MAX}
                                value={reason}
                                onChange={(e) => setReason(e.target.value)}
                                placeholder="Why is this trip starting early?"
                                disabled={submitting}
                            />
                            <div className="form-text text-end">{length}/{REASON_MAX}</div>
                        </div>
                        <div className="modal-footer">
                            <button type="button" className="btn btn-outline-secondary" onClick={onClose} disabled={submitting}>Cancel</button>
                            <button type="button" className="btn btn-warning" onClick={submit} disabled={submitting || !valid}>
                                {submitting ? "Saving..." : "Allow Early Start"}
                            </button>
                        </div>
                    </div>
                </div>
            </div>
            <div className="modal-backdrop fade show"></div>
        </>
    );
};

export default EarlyStartModal;
